import { render, staticRenderFns } from "./GsRichTextEditor.vue?vue&type=template&id=4c0ad406"
import script from "./GsRichTextEditor.vue?vue&type=script&lang=js"
export * from "./GsRichTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports